<template>
  <div>
    {{ selectedPlan.cartCapacity }} {{ selectedPlan.cartCapacityUnit }} • {{ $money(selectedPlan.amount) }} • {{ subscriptionCycleDesc }}
  </div>
</template>
<script>
import { getSubscriptionCycleDesc } from '@/common/product-unit';

export default {
  props: {
    selectedPlan: Object,
  },
  computed: {
    subscriptionCycleDesc() {
      return getSubscriptionCycleDesc(this.selectedPlan.billing_cycle);
    }
  }
};
</script>
